import { Button } from "primereact/button";
import * as React from "react";
import { useTranslation } from "react-i18next";
import "./PrwcOutlinedButton.scss";

const PrwcOutlinedButton = (props: any) => {
  const { onClick, labelKey, className, type = "button", icon } = props;
  const { t } = useTranslation();

  return (
    <div className="prw-outlined-button">
      <Button
        icon={icon}
        onClick={onClick}
        type={type}
        label={t(labelKey)}
        className={className}
      />
    </div>
  );
};

export default PrwcOutlinedButton;
